var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layoutSidenav_content"}},[_vm._t("Main"),_vm._t("Footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }